import { ItemShownEvent } from '~/shared/event_subjects'
import { Subscription } from 'rxjs'

import GtmEmitterState from './gtm_emitter_state'
import InitialGtmEmitterState from './initial_gtm_emitter_state'
import ElapsedTimeCounter from './elapsed_time_counter'

export type StoreData = {
  // ページ情報
  pageData: {} | null,
  // イベント回数
  eventCount: {},
  // 経過時間
  elapsedSec: number
}

export type EventData = {
  event: string,
  storeData: StoreData | null,
  eventData?: {}
}

export default class GtmEmitter {
  store: StoreData
  timeCounter: ElapsedTimeCounter
  timeCounterSubscription: Subscription
  state: GtmEmitterState

  constructor () {
    this.timeCounterSubscription = new Subscription()
    this.state = new InitialGtmEmitterState()
    this.state.onEnterState(this)
  }

  changeState (newState: GtmEmitterState) {
    this.state = newState
    this.state.onEnterState(this)
  }

  onPlaceChanged (e: ItemShownEvent) {
    this.state.onPlaceChanged(this, e)
  }

  onEnterPage (pageData: {}) {
    this.state.onEnterPage(this, pageData)
  }

  onEvent (name: string, data: {} = {}) {
    this.state.onEvent(this, name, data)
  }

  currentPlaceId () : number | null {
    if (this.store.pageData && this.store.pageData.placeId) {
      return this.store.pageData.placeId
    }
    return null
  }

  emitUid (uid: string | null) {
    this._emitRawData({ nurveUid: uid })
  }

  setupBrowser (window: EventTarget) {
    window.addEventListener('pagehide', () => {
      this.state.terminate(this)
    })
    window.addEventListener('beforeunload', () => {
      this.state.terminate(this)
    })
    // terminate 済みの状態で bfcache から復元されると計測が止まるため
    window.addEventListener('pageshow', (e) => {
      if ((e as PageTransitionEvent).persisted) global.location.reload()
    })
  }

  // --- GtmEmitterState 用の helper methods ---

  forceEmitEvent (name: string, data: {} = {}) {
    const eventCountData = this.store.eventCount
    eventCountData[name] = eventCountData[name] || 0
    eventCountData[name] += 1
    this.commitEventData()
    this.emitEventData({
      event: `event_${name}`,
      storeData: this.store,
      eventData: data
    })
  }

  emitEventData (data: EventData) {
    this._emitRawData(data)
  }

  _emitRawData (data: any) {
    global.dataLayer = global.dataLayer || []
    global.dataLayer.push(data)
  }

  clearPageData () {
    this.commitStoreData()
    this.store.pageData = null
    this.store.eventCount = {}
  }

  resetStoreData () {
    this.store = {
      pageData: null,
      eventCount: {},
      elapsedSec: 0
    }
  }

  // 以前までのページの情報をクリアするために emit する
  commitStoreData () {
    this._emitRawData({
      // 一旦nullを入れてクリアしないと今までのstore_dataの値がマージされてしまうため
      storeData: null
    })
  }

  commitEventData () {
    this._emitRawData({
      // 一旦nullを入れてクリアしないと今までのevent_dataの値がマージされてしまうため
      eventData: null
    })
  }
}
